import { useContext, useState } from 'react';
import { SmartContext } from '../../../../../../library/Core/SmartContext';
import DigitalCampaign from './DigitalCampaign';
import General from './General';
import PlatformUsage from './PlatformUsage';

const Interests = () => {
    const { state } = useContext(SmartContext);
    const [activeTab, setActiveTab] = useState('digital-campaign');

    const handleTabChange = (tab:any) => {
        setActiveTab(tab);
    };


    return (
        <div className="tab-pane fade show active" id="pills-interest" role="tabpanel" aria-labelledby="pills-interest-tab">
            <div className="d-flex flex-wrap flex-column flex-md-row">
                <div
                    className="nav flex-row flex-md-column nav-pills custom-sub-tab"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical">
                     <button
                        className={`nav-link ${activeTab === 'digital-campaign' ? 'active' : ''}`}
                        id="v-pills-digital-campaign-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-digital-campaign"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-digital-campaign"
                        aria-selected={activeTab === 'digital-campaign'}
                        onClick={() => handleTabChange('digital-campaign')}>
                        Digital Campaign
                    </button>
                    <button
                        className={`nav-link ${activeTab === 'general' ? 'active' : ''}`}
                        id="v-pills-general-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-general"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-general"
                        aria-selected={activeTab === 'general'}
                        onClick={() => handleTabChange('general')}>
                        General
                    </button>
                    <button
                        className={`nav-link ${activeTab === 'platform-usage' ? 'active' : ''}`}
                        id="v-pills-platform-usage-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#v-pills-platform-usage"
                        type="button"
                        role="tab"
                        aria-controls="v-pills-platform-usage"
                        aria-selected={activeTab === 'platform-usage'}
                        onClick={() => handleTabChange('platform-usage')}>
                        Platform Usage
                    </button>
                </div>
                <div className="tab-content p-3 p-sm-4 p-md-5 bg-gray-F2F4F7 flex-1" id="v-pills-tabContent">
                    {activeTab === 'digital-campaign' && <DigitalCampaign />}
                    {activeTab === 'general' && <General />}
                    {activeTab === 'platform-usage' && <PlatformUsage />}
                </div>
            </div>
        </div>
    );
};

export default Interests;
